export default "__VITE_ASSET__8nPfsThi__"